module.exports = __webpack_public_path__ + "static/33-Kaltura-d2e66cb451e5c659cbad7d9b901b7ffc.png";